import TotalsLine from '../common/list/TotalsLine';
import { getNumberComma } from '../../utils/numberUtils';

const TaxbillTotalSummary = ({ totalPrice }) => {
  const items = [{ label: '총 계산서 금액', value: getNumberComma(totalPrice) }];
  return <TotalsLine items={items} />;
};

export default TaxbillTotalSummary;
